import React, { useState } from "react";
import FieldForceAccountViewAll, { FIELD_FORCE_VIEW_ALL_EMBEDDED } from "..";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../../assets/Icons";
import BeneficiaryAccountViewAll from "../../../Accounts/BeneficiaryAccount/BeneficiaryAccountViewAll";
import ReimbursementAccountViewAll from "../../../Accounts/ReimbursementAccount/AccountViewAll";
import CommonToast from "../../../../components/_utils/CommonToast";
import TaxationAccountViewAll from "../../../Accounts/TaxationAccount/TaxationAccountViewAll";

const FieldForceAccountAssociatePopup = ({
  handleClick,
  handleCloseModal,
  createFieldForceAccountLoading,
  showModalPopup,
  accountNumber,
  ifsc,
  panNumber,
  setActiveType,
  setRemPan,
  setRemAccount,
  setRemIFSC,
  remIFSC,
  remAccount,
  remPan,
  activeType,
  isBottomRequired,
  id,
}) => {
  const dropDownOptions = [
    "Field force account",
    "Beneficiary account",
    "Reimbursement account",
    "Tax account",
  ];
  const [currentAssociate, setCurrentAssociate] = useState(
    "Field force account",
  );
  const handleDropdownChange = (val) => {
    setActiveType("Pan");
    setRemPan(panNumber);
    setRemAccount("");
    setRemIFSC("");
    setCurrentAssociate(val);
  };

  const handleCloseValue = () => {
    setActiveType("Pan");
    setRemPan(panNumber);
    setRemAccount("");
    setRemIFSC("");
    setCurrentAssociate(dropDownOptions[0]);
  };

  const handleClosePopup = () => {
    setCurrentAssociate("Field force account");
    handleCloseModal();
  };

  return (
    <LargePopupRedirect
      closeiconhandleFunction={handleClosePopup}
      isfullViewrequired={false}
      ispanbankRequired={true}
      isDropDownRequired={true}
      dropDownValue={currentAssociate}
      dropDownOptions={dropDownOptions}
      handleDropdownChange={handleDropdownChange}
      handleCloseValue={handleCloseValue}
      togglepan={() => {
        setActiveType("Pan");
        setRemPan(panNumber);
        setRemAccount("");
        setRemIFSC("");
      }}
      toggleBank={() => {
        setActiveType("Bank");
        setRemPan("");
        setRemAccount(accountNumber);
        setRemIFSC(ifsc);
      }}
      fullviewbtnText="Register a new account"
      redirectHeader="Register a new account"
      fullviewhandleFunction={() => {
        // handleClosePopup();
        // navigate("/beneficiary_account_dashboard/create_beneficiary_account");
      }}
      redirectIcon={
        "https://q2pay.in/new_assets/common/settings/add_button_white.svg"
      }
      fullviewicon={ICONS?.REDIRECT}
      initialPanTab={activeType}
      headerTitle={
        isBottomRequired
          ? "Are you sure you want to create this account?"
          : "Associate accounts"
      }
      headersubtext={
        !isBottomRequired &&
        "The accounts listed below are linked to the selected field force account. "
      }
      isbottomSectionneed={isBottomRequired}
      bottomHeaderTextNeed={true}
      bottomHeaderText={
        "On creating a new account, it gets added to the list of active accounts below as a 'pending' account for the PAN and Bank provided."
      }
      confirmbtnrequired={showModalPopup}
      btnText={"Create"}
      isDisabled={createFieldForceAccountLoading}
      isLoaderNeeded={true}
      isLoading={createFieldForceAccountLoading}
      enabledBgColor={"var(--positive-act)"}
      enabledTextColor={"var(--text-primary)"}
      disabledBgColor={
        createFieldForceAccountLoading
          ? "var(--positive-act)"
          : "var(--text-disabled)"
      }
      disabledTextColor={"var(--text-primary)"}
      outLineColor={""}
      hoverOption={"dark"}
      handleFunction={handleClick}
    >
      {currentAssociate === "Field force account" ? (
        <FieldForceAccountViewAll
          type={"fieldForceAccount"}
          fieldForcePan={remPan}
          fieldForceIFSC={remIFSC}
          fieldForceAccountNo={remAccount}
          classifiedFlow={true}
          handleClosePopup={handleClosePopup}
          id={id}
        />
      ) : currentAssociate === "Reimbursement account" ? (
        <ReimbursementAccountViewAll
          type={"ReimbursementAcc"}
          remPan={remPan}
          remAccount={remAccount}
          remIFSC={remIFSC}
          mainType={"create"}
          classifiedFlow={true}
        />
      ) : currentAssociate === "Tax account" ? (
        <TaxationAccountViewAll
          type={"TaxAcc"}
          remPan={remPan}
          remAccount={remAccount}
          remIFSC={remIFSC}
          activeType={activeType}
          // searchPanText={searchPanText}
          // currentAccountDetails={payload}
          setOpenBeneAssociate={handleCloseModal}
          classifiedFlow={true}
          // cardsType="ViewOnlyCards"
          // onCardNavigate={handleCardClick}
        />
      ) : (
        <BeneficiaryAccountViewAll
          typepop={"popup"}
          alertPop={"AlertPopAsso"}
          handleClick={handleClick}
          showModalPopup={showModalPopup}
          remPan={remPan}
          remAccount={remAccount}
          classifiedFlow={true}
          remIFSC={remIFSC}
          handleButtonClick={() => {
            CommonToast({
              text: "Action restricted in popup mode.",
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
              btnProps: {
                enabledBgColor: "var(--primary-bg)",
                enabledTextColor: "var(--text-primary)",
                btnText: "",
                handleFunction: () => {},
                icon: "",
                btnType: "button",
                isDisabled: false,
                hoverOption: "white",
              },
            });
          }}
        />
      )}
    </LargePopupRedirect>
  );
};

export default FieldForceAccountAssociatePopup;
